import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { initialState } from './state';
import { fetchingContinueShopping } from './actions';

export const reducer = reducerWithInitialState(initialState)
    .case(fetchingContinueShopping.started, state => ({
        ...state,
        loading: true,
    }))
    .case(fetchingContinueShopping.done, (state, { result }) => ({
        ...state,
        data: result,
        loading: false,
    }))
    .case(fetchingContinueShopping.failed, (state, { error }) => ({
        ...state,
        data: [],
        loading: false,
        error,
    }));

export default reducer;
